/* eslint-disable */
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import RecoilRootWrapper from "./recoil/RecoilRoot";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
declare global {
  interface Window {
    naver: any;
  }
}
root.render(
  <RecoilRootWrapper>
    <App />
  </RecoilRootWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
